import { useQuery } from '@tanstack/react-query';

import { listOfferRegionFilterExclusions } from '~/services/PromoService';

import { offerRegionFilterExclusionQueryKeys } from './offerRegionFilterExclusionQueryKeys';

type Params = {
  query: Parameters<typeof listOfferRegionFilterExclusions>[0];
  enabled?: boolean;
};

export function useListOfferRegionFilterExclusions({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: offerRegionFilterExclusionQueryKeys.list(query),
    queryFn: async ({ signal }) => listOfferRegionFilterExclusions(query, { signal }),
    enabled,
  });
}
